export enum ComplianceListColumnsEnum {
  STUDENT_ID = 'Student ID',
  LAST_NAME = 'Last Name',
  FIRST_NAME = 'First Name',
  HOMEROOM = 'Homeroom',
  GRADE = 'Grade',
  ENTRY_DATE = 'Entry Date',
  ENTRY_TIME = 'Entry Time',
  BEHAVIOR_CODE = 'Behavior Code',
  REACTION = 'Reaction',
  REACTION_DATE = 'Reaction Date',
  ISSUED_BY = 'Issued By',
  COMPLY = 'Comply'
}
